<template>
  <Tweet
    tweet_link="https://x.com/ton_blockchain/status/1935703248842965308"
    image_name="ton.png"
    name="TON 💎"
    handle="@ton_blockchain"
    is_verified
    is_gold
  >
    🫧 <b>@bubblemaps</b> is now live on TON! Dive into real-time visual
    analytics for the ecosystem<br /><br />
    Ready to get powerful onchain insights? Try it now
  </Tweet>
</template>

<script>
import Tweet from "@/components/atoms/Tweet.vue";

export default {
  components: {
    Tweet,
  },
};
</script>
